// extracted by mini-css-extract-plugin
export default {"textArea":"Answer_textArea__SYZgM","prefix":"Answer_prefix__0o8+r","answer":"Answer_answer__jgBoH"};